import * as React from "react";
import {
  Edit,
  EditProps,
  SimpleForm,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";
import { StoredImage } from "../../../types";

const SocialsEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="icon"
          fullWidth
          label={false}
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          source="picture"
          format={(value: StoredImage) => {
            if (!value) return [];
            if (typeof value === "string")
              return [
                {
                  src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value}`,
                },
              ];
            return value;
          }}
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="title" label={`socials.title`} />
        </TranslatableInputs>
        <TextInput fullWidth source="link" label="socials.link" />
      </SimpleForm>
    </Edit>
  );
};

export default SocialsEdit;
